module.exports = __webpack_public_path__ + "static/media/Step5.82fece07.png";